export default __webpack_public_path__ + "static/media/Taxes_Icon.6ae90e2f.svg";